import type { DocMigration } from "../docMigration";

// Round degrees to 2 decimal places so that we don't end up with weird angles like 359.99999999999994
const radianToDegree = (rad: number): number => Math.round(rad * (180 / Math.PI) * 100) / 100;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_509: DocMigration = {
  maxSchemaVersion: "0.0.509",
  description: "Convert angles stored in radians to degrees",
  apply(json: any): any {
    const { contentTemplateInstances = {} } = json;

    for (const id of Object.keys(contentTemplateInstances)) {
      const instance = contentTemplateInstances[id];
      if (instance.templateType === "DRAWING") {
        instance.rotation = radianToDegree(instance.rotation ?? 0);
      }
    }

    const { annotation: annotationTable = {} } = json;
    for (const id of Object.keys(annotationTable)) {
      const annotation = annotationTable[id];
      if (annotation.type === "NOTE" && typeof annotation.rotation === "number") {
        annotation.rotation = radianToDegree(annotation.rotation);
      }
      if (
        annotation.type === "DETAIL" &&
        annotation.detailType === "ASSET_REFERENCE" &&
        typeof annotation.rotation === "number"
      ) {
        annotation.rotation = radianToDegree(annotation.rotation);
      }
    }

    const { settings: settingsTable = {} } = json;
    for (const id of Object.keys(settingsTable)) {
      const settings = settingsTable[id];
      if (settings.type === "ANNOTATION_CATALOG_SETTINGS") {
        settings.annotationTemplates = settings.annotationTemplates ?? {};
        const templates: any[] = Object.values(settings.annotationTemplates);
        for (const template of templates) {
          const components: any[] = Object.values(template.components ?? {});
          for (const component of components) {
            if (component.type === "NOTE" && typeof component.rotation === "number") {
              component.rotation = radianToDegree(component.rotation);
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_509;
